import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const updateDepartmentColors = (departments) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.put(
                `${FIRMFLOWURL}api/Department/colors`,
                { departments },
                {
                    headers: { Authorization: token },
                },
            );

            resolve({ ...response, success: true });
        } catch (err) {
            console.log("error on updating department colors", err);

            const status = err?.response?.status;

            if (status === 401) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }

            const serverMessage =
                err?.response?.data?.message ||
                err?.response?.data?.Message ||
                err?.response?.data?.title ||
                err?.message;

            resolve({
                success: false,
                status,
                message: serverMessage || "Failed to save colors.",
            });
        }
    });
};
